/* VoluFine · rangées qui glissent (ingrédients, vidéos, avis) : au doigt c'est natif ; à la souris on peut tirer la rangée
   comme chez la source (Flickity). La page ne bouge jamais : on ne touche qu'au défilement horizontal de la rangée. */
(function(){
  if(window.__svVfDrag)return; window.__svVfDrag=1;
  function init(t){
    if(t.dataset.dragReady)return; t.dataset.dragReady='1';
    var down=false,x0=0,s0=0,moved=0;
    t.addEventListener('pointerdown',function(e){ if(e.pointerType!=='mouse'||e.button!==0)return; down=true; moved=0; x0=e.clientX; s0=t.scrollLeft; });
    window.addEventListener('pointermove',function(e){ if(!down)return; var d=e.clientX-x0; if(Math.abs(d)>4&&!t.classList.contains('is-drag'))t.classList.add('is-drag');
      if(t.classList.contains('is-drag')){ moved=d; t.scrollLeft=s0-d; e.preventDefault(); } });
    function up(){ if(!down)return; down=false; if(!t.classList.contains('is-drag'))return;
      t.classList.remove('is-drag');
      /* se remet sur la carte la plus proche, en douceur */
      var kids=[].slice.call(t.children), best=null, bd=1e9, left=t.getBoundingClientRect().left+parseFloat(getComputedStyle(t).paddingLeft||0);
      kids.forEach(function(k){ var d=Math.abs(k.getBoundingClientRect().left-left); if(d<bd&&k.offsetWidth){bd=d;best=k;} });
      if(best)t.scrollBy({left:best.getBoundingClientRect().left-left,behavior:'smooth'});
      if(Math.abs(moved)>4){ var stop=function(ev){ ev.preventDefault(); ev.stopPropagation(); t.removeEventListener('click',stop,true); }; t.addEventListener('click',stop,true); setTimeout(function(){ t.removeEventListener('click',stop,true); },50); }
    }
    window.addEventListener('pointerup',up); window.addEventListener('pointercancel',up);
    t.addEventListener('dragstart',function(e){ e.preventDefault(); });
  }
  function all(){ [].slice.call(document.querySelectorAll('[data-vf-drag]')).forEach(init); }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',all); else all();
  document.addEventListener('shopify:section:load',all);
})();
